<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-clipboard-success`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 3a2 2 0 012 2v2h5a2 2 0 012 2v34a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 012-2h5V5a2 2 0 012-2h18zm-20 8h-3v30h28V11h-3v2a2 2 0 01-2 2H15a2 2 0 01-2-2v-2zm18.293 10.293l1.414 1.414a1 1 0 010 1.414l-10 10a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0L22 29.172l7.879-7.88a1 1 0 011.414 0zM31 7H17v4h14V7z"/></svg>
</template>
<script>

export default {
  name: 'IconClipboardSuccess',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
